'use client';
import { useBreakpoint } from 'components/pcc-components';
import { CatHeading } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

export const ShopByCategoryHeading = () => {
  const t = useTranslations();
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const istablet = useBreakpoint(PAGE_BREAKPOINTS.MD);

  const headingVariant = useMemo(() => {
    if (isDesktop) return 'headline';
    else if (istablet) return 'title';
    else return 'title-sm';
  }, [isDesktop, istablet]);
  return (
    <CatHeading variant={headingVariant} decorator>
      {t('SHOP_BY_CATEGORY')}
    </CatHeading>
  );
};
